// WHIT-493: which brand the site wears. A build-time switch, separate from
// NEXT_PUBLIC_ENV so brand and environment are no longer coupled:
// staging.Dockerfile builds the Allmyles showcase, prod.Dockerfile builds
// Tipptour. Pure (no DOM, no React) so `node --test web/utils/brand.test.js`
// can load it.

const TIPPTOUR = 'tipptour';
const ALLMYLES = 'allmyles';

// Only the exact string 'allmyles' selects it: an unset, empty or mistyped
// value keeps Tipptour, so a build that forgets the variable can never put the
// showcase brand on tipptour.com.
const brandOf = value => (value === ALLMYLES ? ALLMYLES : TIPPTOUR);

// The tt- colours as plain hex, for the few places a CSS variable cannot
// reach: the Stripe and Revolut card fields (separate frames), the Mapbox
// route line and the MUI theme. Everywhere else reads the variables in
// styles/globals.css; brand.test.js keeps the two in step.
const TIPPTOUR_COLOURS = {
  'tt-dark-purple': '#6a0096',
  'tt-verydark-purple': '#2e0041',
  'tt-verylight-purple': '#f2ebf6',
  'tt-light-purple': '#b896d0',
  'tt-light-gray-purple': '#706774',
  'tt-dark-yellow': '#deb000',
  'tt-error-red': '#ec003e',
};
const ALLMYLES_COLOURS = {
  'tt-dark-purple': '#515cf0',
  'tt-verydark-purple': '#0a0d35',
  'tt-verylight-purple': '#e9ecff',
  'tt-light-purple': '#a3a8ff',
  'tt-light-gray-purple': '#5b6372',
  'tt-dark-yellow': '#3f49d9',
  'tt-error-red': '#ec003e',
};

const BRANDS = {
  [TIPPTOUR]: {
    colours: TIPPTOUR_COLOURS,
    name: 'Tipptour',
    // Black text on the yellow solid button; the search tabs carry emoji.
    solidButtonText: 'text-black',
    searchTabEmoji: true,
    // Result cards name the fare's source (GDS, NDC, LCC).
    showProviderType: true,
    // web/public/prod and web/public/dev hold the two favicon sets.
    faviconDir: '/prod',
    tileColor: '#da532c',
    siteUrl: 'https://tipptour.com/',
    structuredDataLogo: 'TipptourLogo.jpg',
  },
  [ALLMYLES]: {
    colours: ALLMYLES_COLOURS,
    name: 'Allmyles',
    // White on the blue solid button (5.1:1); emoji are off-brand.
    solidButtonText: 'text-white',
    searchTabEmoji: false,
    // Only the labels a traveller reads (cheapest, fastest); the fare's
    // source is supplier detail.
    showProviderType: false,
    faviconDir: '/dev',
    tileColor: '#515cf0',
    siteUrl: 'https://showcase.allmyles.com/',
    structuredDataLogo: 'ShowcaseLogo.jpg',
  },
};

// Read with the full name so Next.js inlines it at build time.
const BRAND = brandOf(process.env.NEXT_PUBLIC_BRAND);

module.exports = {
  TIPPTOUR,
  ALLMYLES,
  brandOf,
  BRANDS,
  BRAND,
  IS_ALLMYLES: BRAND === ALLMYLES,
  brandConfig: BRANDS[BRAND],
};
